$(function() {
  var currentAjaxRequest = null;
  var searchForms = $('form[action="/search"]').css('position', 'relative').each(function() {
      var input = $(this).find('input[name="q"]');
      input.attr('autocomplete', 'off').bind('keyup change', function() {
          var term = $(this).val();
          var form = $(this).closest('form');
          var searchURL = '/search?type=product&q=*' + term + '*';
          var resultsList = $('.et-search-results-wrap');
          var resultsList2 = $('.et-search-results__more');
          // resultsList.perfectScrollbar({
          //     suppressScrollX: true
          // });
          if (term.length > 3 && term !== $(this).attr('data-old-term')) {
              $(this).attr('data-old-term', term);
              if (currentAjaxRequest !== null) currentAjaxRequest.abort();
              currentAjaxRequest = $.getJSON(searchURL + '&view=json', function(data) {
                  resultsList.empty();
                  resultsList2.empty();
                  if (data.results_count === 0) {
                      resultsList.html('<p>No results.</p>');
                      resultsList.fadeIn(200);
                  } else {
                      $.each(data.results, function(index, item) {
                          var link = $('<a></a>').attr('href', item.url);
                          link.append('<div class="thumbnail"><img src="' + item.thumbnail + '" /></div>');
                          link.append('<h2>' + item.title + '</h2>');
                          link.append('<p>' + item.price + '</p>');
                          link.wrap('<div class="et-ajax-search-product-item"></div>');
                          resultsList.append(link.parent());
                      });
                      if (data.results_count > 5) {
                        resultsList2.append('<a href="' + searchURL + '"> + More Results </a>');
                      }
                      resultsList.fadeIn(200);
                  }
              });
          }
      });
  });
  // Clicking outside makes the results disappear.
    //  $('body').bind('click', function(){
    //     $('.search-results').hide();
    //   });
});